/*! idTabs v3.1 ~ Sean Catchpole - Copyright 2016 MIT/GPL */
;(function($) {

// Helper functions
  var idTabs, //shortcut
      undefined,  //speed up
      tab = function(e) { return $(e).data('tab'); },
      type = function(o) { //reliable
        return o === null && 'Null'
            || o === undefined && 'Undefined'
            || ({}).toString.call(o).slice(8, -1);
      };

  $.fn.idTabs = function() {
    var s = idTabs.args.apply(this, arguments),
        action = s.update && 'update' || s.remove && 'remove' || 'bind';
    s.area = this; //save context
    idTabs[action](s);
    return this; //chainable
  };

  idTabs = $.idTabs = function(tabarea, options, data) {
    // Settings
    var e, tabs, items, test = $(), meta = $.metadata ? $(tabarea).metadata() : {}, //metadata
        s = {
          tab : idTabs.tab,
          item: idTabs.item,
        }; //helpers
    s = $.extend(s, idTabs.settings, meta, options || {}); //settings
    s.tabarea = $(tabarea); //save context
    s.data = data || 'idTabs' + +new Date; //save expando

    console.log(s);

    // Play nice
    $.each({
      selected: '.',
      event   : '!',
      start   : '#',
    }, function(n, c) {
      if (type(s[n]) === 'String' && parseInt(s[n].indexOf(c)) === 0) {
        s[n] = s[n].substr(1);
      }
    }); //removes type characters
    if (s.start === null) {
      s.start = -1;
    } //no tab selected

    // Find tabs
    items = []; //save elements
    s.tabs = tabs = $('a[data-tab^=\\#]', tabarea); //save tabs

    tabs.each(function() { //add items
      test = s.item(tab(this));
      if (test.length) {
        items = items.concat(test.get());
      }
    });

    s.items = $(items).hide(); //hide items

    // Save Settings
    e = 'idTabs.' + s.event;
    data = s.tabarea.data('idTabs') || {};
    data[e] = s;
    s.tabarea.data('idTabs', data);

    // Bind idTabs
    tabs.trigger(e).data(s.data, s).bind(e, {s: s}, function() { //wrapper function due to jQuery bug
      return idTabs.unbind.apply(this, arguments);
    }).bind(s.event, {s: s}, idTabs.find);

    // Select default tab
    type(s.start) === 'Number' && (s.start < 0 || (test = tabs.eq(s.start)).length)
    || type(s.start) == 'String' && (test = tabs.filter('a[data-tab=#"' + s.start + '"]')).length
    || (test = tabs.filter('.' + s.selected).removeClass(s.selected)).length
    || (s.start === undefined && (test = tabs.eq(0)).length);
    if (test.length) {
      test.trigger(s.event);
    }

    return s; //return current settings (be creative)
  };

  /**
   * 解析参数到设置
   */
  idTabs.args = function() {
    var a, i = 0, s = {}, args = arguments,
        // Handle string flags .!:
        str = function(_, a) {
          if (parseInt(a.indexOf('.')) === 0) {
            s.selected = a;
          } else if (parseInt(a.indexOf('!')) === 0) {
            if (/^!(true|false)$/i.test(a)) {
              s.toggle = /^!true$/i.test(a);
            } else {
              s.event = a;
            }
          } else if (parseInt(a.indexOf(':')) === 0) {
            a = a.substr(1).toLowerCase();
            if (parseInt(a.indexOf('!')) === 0) {
              s[a.substr(1)] = false;
            } else {
              s[a] = true;
            }
          } else if (a) {
            s.start = a;
          }
        };
    // Loop through arguments matching options
    while (i < args.length) {
      a = args[i++];
      switch (type(a)) {
        case 'Object'   :
          $.extend(s, a);
          break;
        case 'Boolean'  :
          s.change = a;
          break;
        case 'Number'   :
          s.start = a;
          break;
        case 'Function' :
          s.click = a;
          break;
        case 'Null'     :
          s.start = a;
          break;
        case 'String'   :
          $.each(a.split(/\s+/g), str);
        default:
          break;
      }
    }
    return s; //settings object
  };

  /**
   * 绑定
   *
   * @param s
   */
  idTabs.bind = function(s) {
    if (!s) {
      return;
    }
    var data = 'idTabs' + +new Date; //instance expando
    if (s.grouped) {
      $.idTabs(s.area, s, data);
    } else {
      s.area.each(function() { $.idTabs(this, s, data); });
    }
  };

  /**
   * 重新绑定
   *
   * @param s
   * @returns {*}
   */
  idTabs.update = function(s) {
    if (!s) {
      return;
    }
    s.update = false;
    var self, data, n, e = s.event;
    e = parseInt((e + '').indexOf('!')) === 0 && e.substr(1) || e;
    e = e ? 'idTabs.' + e : '';
    return s.area.each(function() {
      self = $(this);
      data = self.data('idTabs');
      if (!data) {
        return;
      }
      if (e) {
        n = $.extend({}, data[e], s);
        idTabs.remove(data[e]);
        idTabs(n.tabarea, n, n.data);
      } else {
        for (e in data) {
          if (!Object.hasOwnProperty.call(data, e)) {
            continue;
          }
          n = $.extend({}, data[e], s);
          idTabs.remove(data[e]);
          idTabs(n.tabarea, n, n.data);
        }
      }
    });
  };

  /**
   * 移除 Tab
   *
   * @param s
   * @returns {*}
   */
  idTabs.remove = function(s) {
    if (!s) {
      return;
    }
    var data, tabs, e = s.event;
    e = parseInt((e + '').indexOf('!')) === 0 && e.substr(1) || e;
    e = 'idTabs' + (e ? '.' + e : '');
    return s.area.each(function() {
      data = $(this).data('idTabs');
      delete data['idTabs.' + s.event];
      $(this).data('idTabs', data);
      tabs = s.tabs || $('a[data-tab^=\\#]', this); //save tabs
      if (!tabs.length && $(this).is('a[data-tab^=\\#]')) {
        tabs = $(this);
      }
      tabs.trigger(e);
    });
  };

  /**
   * 查找 Tab
   *
   * @param e
   * @returns {boolean}
   */
  idTabs.find = function(e) {
    // Save self since clicked tab may not be the first tab in the tabarea
    var self = this, ret = false, s = e.data.s;
    // Find first tab within each tabset
    $('a[data-tab="' + tab(this) + '"]:first', s.area).each(function() {
      var t = $(this).data(s.data); //tab's settings
      if (t) {
        ret = idTabs.showtab.call(t.tabarea === s.tabarea ? self : this, t, e) || ret;
      }
    });
    return ret;
  };

  /**
   * 显示选项卡
   *
   * @param s
   * @param e
   * @returns {*}
   */
  idTabs.showtab = function(s, e) {
    if (!s || !s.toggle && $(this).is('.' + s.selected)) {
      return s && s.change;
    } //return if already selected
    var id = tab(this); //find id
    if (s.click && Boolean(s.click.call(this, id, s, e)) === false) {
      return s.change;
    } //call custom func
    if (s.toggle && $(this).is('.' + s.selected)) {
      id = null;
    } //hide items
    return idTabs.show.call(this, id, s, e); //call default func
  };

  /**
   * 显示选项卡条目
   *
   * @param id
   * @param s
   * @returns {*}
   */
  idTabs.show = function(id, s) {
    s.tabs.parent().siblings().removeClass(s.selected); //clear tabs
    s.tab(id).parent().addClass(s.selected); //select tab(s)

    s.items.hide().removeClass(s.selected); //hide all items
    s.item(id).show().addClass(s.selected); //show item(s)
    return s.change; //option for changing url
  };

  /**
   * 取消绑定 idTabs
   *
   * @param e
   * @returns {boolean}
   */
  idTabs.unbind = function(e) {
    var s = e.data.s;
    $(this).removeData(s.data).unbind('idTabs.' + s.event);
    return false;
  };

  /**
   * 扩展 idTabs
   *
   * @returns {Function}
   */
  idTabs.extend = function() {
    var args = arguments;
    return function() {
      [].push.apply(args, arguments);
      this.idTabs.apply(this, args);
    };
  };

  /**
   * 匹配 tab
   *
   * @param id
   * @returns {*|jQuery|HTMLElement}
   */
  idTabs.tab = function(id) {
    if (!id) {
      return $([]);
    }
    return $('a[data-tab="' + id + '"]', this.tabarea);
  };

  /**
   * 匹配内容
   *
   * @param id
   * @returns {*|jQuery|HTMLElement|*}
   */
  idTabs.item = function(id) {
    if (!id) {
      return $([]);
    }
    var item = $(id);
    console.log(item);
    return item.length ? item : $('.' + id.substr(1));
  };

  /**
   * 默认选项
   *
   * @type {{grouped : boolean, change : boolean, start : undefined, toggle : boolean, event : string, click : null, selected : string}}
   */
  idTabs.settings = {
    start   : undefined,
    change  : false,
    click   : null,
    selected: '.is-active',
    event   : '!click',
    toggle  : false,
    grouped : false,
  };

  /**
   * 版本号
   *
   * @type {string}
   */
  idTabs.version = '3.0';

  /**
   * 自动运行
   */
  $(function() { $('.idTabs').idTabs(); });

})(jQuery);
